import { ShieldAlert, AlertTriangle, Info } from "lucide-react";
import type { Critique } from "../../domain/types";
import { cn } from "../common/cn";

interface CritiqueBadgeProps {
  critique: Critique;
  showFlaw?: boolean;
}

const CONFIG = {
  minor: {
    label: "minör",
    Icon: Info,
    className: "border-slate-400/40 bg-slate-500/10 text-slate-200",
  },
  major: {
    label: "majör",
    Icon: AlertTriangle,
    className: "border-amber-400/55 bg-amber-500/12 text-amber-200",
  },
  blocker: {
    label: "blocker",
    Icon: ShieldAlert,
    className: "border-rose-500/65 bg-rose-500/15 text-rose-200",
  },
} as const;

export function CritiqueBadge({ critique, showFlaw = true }: CritiqueBadgeProps) {
  const cfg = CONFIG[critique.severity];
  const Icon = cfg.Icon;
  return (
    <span
      role="status"
      aria-live="polite"
      title={critique.flaw}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium uppercase tracking-wider",
        cfg.className,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      <span>{cfg.label}</span>
      {showFlaw ? (
        <span className="hidden max-w-[28ch] truncate normal-case font-normal opacity-85 sm:inline-block">
          — {critique.flaw}
        </span>
      ) : null}
    </span>
  );
}
